import { Alert, Box, CircularProgress } from '@mui/material';
import dayjs from 'dayjs';
import { CalendarWithAvailability } from '../../../visits/components/visit-form/components/CalendarWithAvailability';
import { AvailableSlotsGrid } from '../../../visits/components/visit-form/components/AvailableSlotsGrid';
import CustomerServiceSelect from '../CustomerServiceSelect';
import type { PreviewVisit } from '../../pages/booking-page.hooks';
import { useBookingCalendarSection } from './booking-calendar-section.hooks';

type Props = {
  previewVisit: PreviewVisit | undefined;
  setPreviewVisit: (v: PreviewVisit | undefined) => void;
};

export const BookingCalendarSection = ({ previewVisit, setPreviewVisit }: Props) => {
  const {
    control,
    selectedDate,
    serviceIds,
    currentMonth,
    highlightedDays,
    availableSlots,
    isLoadingSlots,
    isLoadingSchedule,
    isScheduleConfigured,
    handleServiceChange,
    handleSlotClick,
    handleCalendarChange,
    handleMonthChange,
  } = useBookingCalendarSection(setPreviewVisit);

  return (
    <>
      <CustomerServiceSelect control={control} onServiceChange={handleServiceChange} />
      {!isLoadingSchedule && !isScheduleConfigured && (
        <Alert severity="info">
          Kadeřník pro tento měsíc ještě nenastavil pracovní dobu. Jakmile ji doplní, zobrazí se zde
          volné termíny.
        </Alert>
      )}
      {serviceIds && (
        <CalendarWithAvailability
          value={selectedDate}
          referenceDate={currentMonth.toDate()}
          isLoading={false}
          highlightedDays={highlightedDays}
          onMonthChange={handleMonthChange}
          onChange={handleCalendarChange}
          minDate={dayjs().add(48, 'hour')}
        />
      )}
      {selectedDate && serviceIds && (
        <>
          {isLoadingSlots ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress size={30} />
            </Box>
          ) : (
            <AvailableSlotsGrid
              availableSlots={availableSlots}
              selectedDate={selectedDate}
              previewStartTime={previewVisit?.startTime}
              onSlotClick={handleSlotClick}
              hasServiceSelected={!!serviceIds}
            />
          )}
        </>
      )}
    </>
  );
};
